// Home
export const HOME = '/home';